import { useToast } from "native-base";

const useCustomToast = () => {
  return useToast();
};

export default useCustomToast;
